import { type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function Protected({ children, admin, customerOnly }: { children: ReactNode; admin?: boolean; customerOnly?: boolean }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="container" style={{ padding: 40 }}>로딩 중...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.status !== "approved" && user.role !== "admin") {
    return (
      <div className="container" style={{ padding: 40, maxWidth: 560 }}>
        <div className="card" style={{ padding: 32 }}>
          <span className="badge badge-warning">승인 대기</span>
          <h2 className="h-title" style={{ marginTop: 12 }}>관리자 승인을 기다리고 있습니다</h2>
          <p className="muted">
            사업자등록증 확인 후 영업일 기준 1일 이내에 승인 처리됩니다.<br />
            문의: 02-000-0000
          </p>
        </div>
      </div>
    );
  }
  if (admin && user.role !== "admin") return <Navigate to="/catalog" replace />;
  if (customerOnly && user.role === "admin") return <Navigate to="/admin" replace />;
  return <>{children}</>;
}
